/*
 * Copyright (c) 2022 LatePoint LLC. All rights reserved.
 */
// @codekit-prepend "bin/time.js"
// @codekit-prepend "bin/shared.js"
// @codekit-prepend "bin/notifications.js";
// @codekit-prepend "bin/actions.js"
// @codekit-prepend "bin/front/main.js"


// DOCUMENT READY
jQuery(document).ready(function( $ ) {

    latepoint_init_customer_dashboard_login();
    latepoint_init_customer_dashboard();

    if(latepoint_helper.start_from_booking_intent_key){

      var data = { 
        action: latepoint_helper.route_action,
        route_name: latepoint_helper.start_from_booking_intent_route, 
        params: { booking_intent_key: latepoint_helper.start_from_booking_intent_key }, 
        layout: 'none', 
        return_format: 'json' 
      }

      $.ajax({
        type : "post",
        dataType : "json",
        url : latepoint_helper.ajaxurl,
        data : data,
        success: function(data){
          if(data.status === "success"){
            var lightbox_class = '';
            latepoint_show_data_in_lightbox(data.message, data.lightbox_class);
            latepoint_init_booking_form();
            var $booking_form_element = jQuery('.latepoint-lightbox-w .latepoint-booking-form-element');
            $booking_form_element.find('.latepoint-step-content').addClass('is-hidden').last().removeClass('is-hidden');
            if($booking_form_element.find('.latepoint-step-content').length > 1) latepoint_show_prev_btn($booking_form_element);
            var $booking_form_element = jQuery('.latepoint-lightbox-w .latepoint-booking-form-element');
            $booking_form_element.find('.latepoint-step-content').each(function(){
              latepoint_init_step($(this).data('step-name'), $booking_form_element);
            });
            $('body').addClass('latepoint-lightbox-active');
          }else{
            // console.log(data.message);
          }
        }
      });
    }

    if($('.latepoint-booking-form-element').length){
      latepoint_init_booking_form();
      $('.latepoint-booking-form-element').each(function(){
        latepoint_init_step($(this).find('.latepoint_current_step').val(), $(this));
      });
    }


    jQuery('body').on('click', '.latepoint-lightbox-close', function(){
      latepoint_lightbox_close();
      return false;
    });


    $('.latepoint-request-booking-cancellation').on('click', function(){
      if(!confirm(latepoint_helper.cancel_booking_prompt)) return false;
      var $this = $(this);
      var $booking_box = $this.closest('.customer-booking');

      var route = $(this).data('route');
      var params = {id: $booking_box.data('id')};

      var data = { action: latepoint_helper.route_action, route_name: route, params: params, layout: 'none', return_format: 'json' }
      $this.addClass('os-loading');
      $.ajax({
        type : "post",
        dataType : "json",
        url : latepoint_helper.ajaxurl,
        data : data,
        success: function(data){
          if(data.status === "success"){
            location.reload();
            $this.remove();
          }else{
            $this.removeClass('os-loading');
          }
        }
      });
      return false;
    });


    $('body').on('click', '.os-step-tabs .os-step-tab', function(){
      $(this).closest('.os-step-tabs').find('.os-step-tab').removeClass('active');
      $(this).addClass('active');
      var target = $(this).data('target');
      $(this).closest('.os-step-tabs-w').find('.os-step-tab-content').hide();
      $(target).show();
    });

    $('body').on('keyup', '.os-form-group .os-form-control', function(){
      if($(this).val()){
        $(this).closest('.os-form-group').addClass('has-value');
      }else{
        $(this).closest('.os-form-group').removeClass('has-value');
      }
    });

    $('.latepoint-tab-triggers').on('click', '.latepoint-tab-trigger', function(){
      var $tabs_wrapper = $(this).closest('.latepoint-tabs-w')
      $tabs_wrapper.find('.latepoint-tab-trigger.active').removeClass('active');
      $tabs_wrapper.find('.latepoint-tab-content').removeClass('active');
      $(this).addClass('active');
      $tabs_wrapper.find('.latepoint-tab-content' + $(this).data('tab-target')).addClass('active');
      return false;
    });


    // Main Button to trigger lightbox opening
    $('body').on('click', '.latepoint-book-button, .os_trigger_booking', function(){
      latepoint_init_booking_form_by_trigger($(this));
      return false;
    });

});
